module.exports = __webpack_public_path__ + "images/fifth_anniversary/campaign-TitleText_2a00af4d7065b69629d7dfbfa861a903.png";